var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrafts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 10V27.5H65",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70H62.5C63.163 70 63.7989 69.7366 64.2678 69.2678C64.7366 68.7989 65 68.163 65 67.5V27.5L47.5 10H17.5C16.837 10 16.2011 10.2634 15.7322 10.7322C15.2634 11.2011 15 11.837 15 12.5V40",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5791 69.1435H17.0313C16.7205 69.1435 16.4224 69.0201 16.2026 68.8003C15.9828 68.5805 15.8594 68.2825 15.8594 67.9717V61.4238C15.8588 61.2717 15.8883 61.1209 15.9461 60.9801C16.004 60.8394 16.089 60.7114 16.1963 60.6035L33.7744 43.0254C33.8835 42.9147 34.0134 42.8267 34.1568 42.7667C34.3001 42.7067 34.454 42.6758 34.6094 42.6758C34.7648 42.6758 34.9186 42.7067 35.062 42.7667C35.2053 42.8267 35.3353 42.9147 35.4443 43.0254L41.9775 49.5586C42.0883 49.6676 42.1762 49.7976 42.2362 49.941C42.2962 50.0843 42.3272 50.2381 42.3272 50.3935C42.3272 50.549 42.2962 50.7028 42.2362 50.8461C42.1762 50.9895 42.0883 51.1195 41.9775 51.2285L24.3994 68.8066C24.2916 68.914 24.1636 68.999 24.0228 69.0568C23.8821 69.1146 23.7313 69.1441 23.5791 69.1435V69.1435Z",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9219 46.875L38.125 55.0781",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts);
export default __webpack_public_path__ + "static/media/drafts.06db4d36a23db070184109caba1169cb.svg";
export { ForwardRef as ReactComponent };